import { createSelector } from '@reduxjs/toolkit';

const sessionDataSelector = ({ sessionData }) => sessionData;

export const localesSelector = createSelector(sessionDataSelector, ({ locales }) => locales.value);

export const localesStatusSelector = createSelector(
  sessionDataSelector,
  ({ locales }) => locales.status,
);

export const countriesSelector = createSelector(
  sessionDataSelector,
  ({ countries }) => countries.value,
);

export const legalEntitiesSelector = createSelector(
  sessionDataSelector,
  ({ legalEntities }) => legalEntities.value,
);

export const legalEntitiesStatusSelector = createSelector(
  sessionDataSelector,
  ({ legalEntities }) => legalEntities.status,
);

export const currenciesSelector = createSelector(
  sessionDataSelector,
  ({ currencies }) => currencies.value,
);
